<viz-footer contactLink="mailto:support@vizientinc.com"
            contactDisplay="Contact"
            appTitle="Application Title"
            copyright="Vizient Inc. All Rights Reserved">
</viz-footer>
